import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';
import {withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import CSSTransition from './CSSTransition';
import {secondary} from '../themes/colors';

const styles = () => ({
    secondaryLoader: {
        backgroundColor: secondary,
    }
});

@observer
class ProgressLoader extends Component {
    @observable complete = 0;
    @observable show = false;

    componentDidMount() {
        if (this.props.show) {
            this.reset();
        }
    }

    componentWillUpdate(nextProps) {
        const {progress, show} = this.props;
        if (nextProps.progress !== progress) {
            this.setProgress(nextProps.progress);
        }
        if (!nextProps.show && show) {
            this.hide();
        } else if (!show && nextProps.show) {
            this.reset();
        }
    }

    componentWillUnmount() {
        this.stop();
    }

    @action hideLoader = () => {
        this.show = false;
    };
    @action setProgress = (progress) => {
        this.complete = progress;
    };
    @action reset = () => {
        this.complete = 0;
        this.show = true;
        this.start();
    };
    @action hide = () => {
        this.complete = 100;
        this.stop();
        setTimeout(() => this.hideLoader(), 600);
    };
    start = () => {
        this.timer = setInterval(() => this.progress(1), 450);
    };

    stop = () => {
        clearTimeout(this.timer);
    };

    @action progress(leap) {
        if (this.complete === 96) {
            this.stop();
        } else {
            this.complete += leap;
        }
    }

    render() {
        const {style, className, progressStyle, classes} = this.props;
        return (
            <div style={style} className={`progress-loader flexbox-fill ${className || ''}`}>
                <CSSTransition animation="fade-quick" className="flexbox-fill">
                    {this.show && <LinearProgress
                        classes={{barColorPrimary: classes.secondaryLoader}}
                        style={progressStyle || {height: '4px', width: '100%'}}
                        variant="determinate"
                        value={this.complete}/>}
                </CSSTransition>
            </div>
        );
    }
}

ProgressLoader.propTypes = {
    show: PropTypes.bool.isRequired,
    color: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    progressStyle: PropTypes.object,
    progress: PropTypes.number
};
export default withStyles(styles)(ProgressLoader);
